module.exports = __webpack_public_path__ + "img/chevron_right_black_24dp.92d5c9b8.svg";